import BaseApi from '../BaseApi';
import Converter from './Converter';

class Api extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);

    this.baseUrl = `${baseUrl}/api/agent_admin/user/sport`;
    this.converter = new Converter();
  }

  getSportHistory = formData =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/coupon/`,
      formData,
      undefined,
      this.converter.convertGetSportHistory,
    );

  getCouponBets = (id) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/coupon/${id}/bets/`,
      undefined,
      undefined,
      this.converter.convertGetCouponBets,
    );

  getBetsMapping = formData =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/mapping`, undefined, undefined, d => d);
}

export default Api;
